module.exports = __webpack_public_path__ + "static/media/logo_white.fdaf45ab.png";